import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  pageTitle: {
    id: 'learnerDashboard.notifications.pageTitle',
    defaultMessage: 'My notifications',
    description: 'Title of the notifications page',
  },
  markAllAsRead: {
    id: 'learnerDashboard.notifications.markAllAsRead',
    defaultMessage: 'Mark all as read',
    description: 'Action that marks every unread notification as read',
  },
  emptyTitle: {
    id: 'learnerDashboard.notifications.emptyTitle',
    defaultMessage: "You're all caught up!",
    description: 'Empty state title when there are no notifications',
  },
  emptyDescription: {
    id: 'learnerDashboard.notifications.emptyDescription',
    defaultMessage: "You'll see new notifications here as they come in.",
    description: 'Empty state description when there are no notifications',
  },
  emptyImageAlt: {
    id: 'learnerDashboard.notifications.emptyImageAlt',
    defaultMessage: 'Illustration of a silent notification bell',
    description: 'Alt text for the empty state illustration on the notifications page',
  },
  loadError: {
    id: 'learnerDashboard.notifications.loadError',
    defaultMessage: 'Failed to load notifications. Please try again later.',
    description: 'Error message shown when notifications fail to load',
  },
});

export default messages;
